/** Shared motion timings, used by every appearance so classic animates too. */
export const MOTION = {
  /** iOS sheet spring: fast start, long soft settle. */
  sheetEase: "cubic-bezier(0.32, 0.72, 0, 1)",
  outEase: "cubic-bezier(0.22, 1, 0.36, 1)",
  sheetMs: 620,
  dimMs: 420,
  collapseMs: 380,
  /** Classic modals fade out quickly; glass sheets take `dimMs`. */
  fadeMs: 200,
  /**
   * Classic Privacy Center accordions. Must not exceed `collapseMs`, after
   * which PCAccordionBody lifts the clipping on an open body.
   */
  classicCollapseMs: 300,
} as const;

/** Duration and curve of a disclosure opening or closing. */
export const COLLAPSE_EASE = `${MOTION.collapseMs}ms ${MOTION.sheetEase}`;

export const prefersReducedMotion = (): boolean =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches === true;
